module.exports = __webpack_public_path__ + "images/left-arrow0268d9a14c48fd4123d6841db6041d29.svg";